module.exports = __webpack_public_path__ + "static/media/jiaodian3.1b3cca74.png";